import { render, staticRenderFns } from "./same_score.vue?vue&type=template&id=33fb9498&scoped=true"
import script from "./same_score.vue?vue&type=script&lang=js"
export * from "./same_score.vue?vue&type=script&lang=js"
import style0 from "./same_score.vue?vue&type=style&index=0&id=33fb9498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb9498",
  null
  
)

export default component.exports